import { AvatarSize, Box, Icon, Text } from '@bechtel/gds';
import { useName } from '@bechtel/ht-clients-common';
import { User } from '@bechtel/ht-types';
import UserPhoto from '../user-photo';
import { UserDetailProps, UserDisplay } from './types';

const UserDetail: React.FC<UserDetailProps> = ({ item, hideIcon }) => {
  const { getFullName } = useName();
  if (!item) {
    return null;
  }
  return (
    <Box flexDirection={{ sm: 'row' }} alignItems={{ sm: 'center' }}>
      <Box mr={{ sm: '400' }}>
        <UserPhoto imageUrl={item.imageUrl || ''} size={AvatarSize.MEDIUM}></UserPhoto>
      </Box>
      <Box flexDirection={{ sm: 'column' }}>
        <Text size="300" family={'openSans'} style={{ lineHeight: '1.5' }}>
          {getFullName(item.firstName, item.lastName)}
        </Text>

        <Text size="200" color="grey.600" transform="capitalize" style={{ lineHeight: '1.8' }}>
          {item.persona || 'User'}
        </Text>
      </Box>
      {!hideIcon && (
        <Box ml={{ sm: '300' }} mb={{ sm: '450' }}>
          <Icon icon="angle-down" iconStyle="duo" />
        </Box>
      )}
    </Box>
  );
};

export default UserDetail;

// The argument can be undefined or null because many objects passed to this function are undefined/ null due to backward compatibility
export function toUserDetail(user?: User | null): UserDisplay {
  return {
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    imageUrl: user?.employee?.imageUrl,
    persona: user?.employee?.persona,
  };
}
